import React, {Component} from 'react';
import {getFoldersByOrg, createFolder} from '../../services/folderService';
import ErrorAlert from "../../components/ErrorAlert";
import SectionCard from "../../patterns/SectionCard";
import {SimpleList, SimpleListRow} from "../../patterns/SimpleList";
import EmptyState from "../../patterns/EmptyState";
import {PanelEmptyIllustration} from "../../patterns/EmptyStateIllustrations";
import FormDialog from "../../patterns/FormDialog";
import Toast from "../../patterns/Toast";
import TextInput from "../../patterns/form/TextInput";
import styles from './OrgPanel.module.css';

export default class Folders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            folders: null,
            folderNameToCreate: '',

            showCreateModal: false,
            createBusy: false,

            createFolderError: null,
            persistentErrorMessage: null,
            toast: null,
        }
    }

    async componentDidMount() {
        try {
            const foldersResponse = await getFoldersByOrg(this.props.org.id);
            this.setState({folders: foldersResponse});
        } catch (error) {
            this.setState({
                persistentErrorMessage: `Problem getting folders: ${error.toString()}`
            });
        }
    }

    cancelCreateFolder = () => {
        this.setState({showCreateModal: false, folderNameToCreate: '', createFolderError: null});
    }

    createClicked = () => {
        this.setState({showCreateModal: true});
    }

    nameChanged = (event) => {
        this.setState({folderNameToCreate: event.target.value});
    }

    createFolder = async () => {
        this.setState({createBusy: true});
        try {
            await createFolder(this.props.org.id, this.state.folderNameToCreate);
            const name = this.state.folderNameToCreate;
            await this.refreshFolders();
            this.setState({
                showCreateModal: false,
                folderNameToCreate: '',
                createBusy: false,
                toast: {message: `${name} created`}
            })
        } catch (e) {
            let message = `Problem creating folder: ${e.toString()}`;
            if (e.response?.data?.error === 'Invalid value') message = `Invalid folder name`;
            else if (e.response?.data?.error) message = e.response.data.error;
            this.setState({createFolderError: message, createBusy: false});
        }
    }

    refreshFolders = async () => {
        const foldersResponse = await getFoldersByOrg(this.props.org.id);
        this.setState({folders: foldersResponse});
    }

    dismissToast = () => this.setState({toast: null});

    render() {
        const {folders, showCreateModal, folderNameToCreate, createBusy, createFolderError,
            persistentErrorMessage, toast} = this.state;

        return (
            <div>
                <SectionCard
                    title="Folders"
                    action={
                        <button type="button" className={styles.addButton} disabled={this.props.disabled}
                                onClick={this.createClicked}>
                            + Add folder
                        </button>
                    }
                >
                    {!folders && !persistentErrorMessage && <p className={styles.loading}>Loading folders…</p>}
                    <ErrorAlert message={persistentErrorMessage} delay={0}/>
                    {folders && (folders.length ? (
                        <SimpleList>
                            {folders.map((folder) => (
                                <SimpleListRow key={folder.id} primary={folder.name}/>
                            ))}
                        </SimpleList>
                    ) : (
                        <EmptyState
                            size="panel"
                            illustration={<PanelEmptyIllustration/>}
                            title="No folders yet"
                            description="Create folders to organise pages in this org."
                        />
                    ))}
                </SectionCard>

                <FormDialog
                    open={showCreateModal}
                    title={`Add a folder to ${this.props.org.name}`}
                    onCancel={this.cancelCreateFolder}
                    onSubmit={this.createFolder}
                    submitLabel="Create"
                    submitDisabled={!folderNameToCreate}
                    busy={createBusy}
                >
                    {(firstFieldRef) => (
                        <TextInput
                            ref={firstFieldRef}
                            id="add-folder-name"
                            label="Folder name"
                            value={folderNameToCreate}
                            onChange={this.nameChanged}
                            error={createFolderError}
                        />
                    )}
                </FormDialog>

                {toast && <Toast message={toast.message} onDismiss={this.dismissToast}/>}
            </div>
        );
    }
}
